export enum EmailType {
  main = '0000',
  personal = '0001',
  work = '0002',
}

export enum EmailTypeLabel {
  main = 'Main',
  personal = 'Personal',
  work = 'Work',
}

export const toEmailTypeLabel = (emailType?: EmailType): EmailTypeLabel | undefined => {
  if (emailType === EmailType.main) return EmailTypeLabel.main;
  if (emailType === EmailType.personal) return EmailTypeLabel.personal;
  if (emailType === EmailType.work) return EmailTypeLabel.work;
  return undefined;
};
